import { Button } from "@chakra-ui/react";
import { useQuery } from "@tanstack/react-query";
import LoadingButton from "./LoadingButton";
import Select, { CustomSelectProps } from "./Select";
import SelectNoResults from "./SelectNoResults";
import useApi from "../hooks/useApi";
import { AgencyTeamId } from "../schema/schema";

export default function AgencyTeamSelect(props: CustomSelectProps<AgencyTeamId>) {
  const { queries } = useApi();

  const query = useQuery(queries.agencyTeam.list());

  switch (query.status) {
    case "pending":
      return <LoadingButton />;
    case "error":
      return (
        <Button
          isDisabled={true}
          justifyContent="flex-start"
          variant="outline"
          {...props.buttonProps}
        >
          Failed to render input
        </Button>
      );
    case "success":
      return (
        <Select
          label={props.multiple ? "Teams" : "Team"}
          options={query.data.agencyTeams.map((x) => ({ value: x.id, label: x.name }))}
          renderAfter={({ searchTerm, filteredOptions }) =>
            filteredOptions.length === 0 && <SelectNoResults searchTerm={searchTerm} />
          }
          {...props}
        />
      );
  }
}
